module.exports = __webpack_public_path__ + "static/media/slots.39f8a4a2.png";